import axios from "axios";
import { TaskCounterSearchParams } from "../types/TaskCounterTypes";

export const fetchGetTaskCounterTemplates = async (data: TaskCounterSearchParams) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return axios.post(`${baseTaskUrl}/TaskCounterTemplate/get-list`, data);
};
